import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';

interface CopyButtonProps {
  textToCopy: string;
  size?: 'small' | 'medium' | 'large';
  className?: string;
  tooltip?: string;
}

export const CopyButton: React.FC<CopyButtonProps> = ({
  textToCopy,
  size = 'small',
  className = '',
  tooltip = 'Copiar',
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (event: React.MouseEvent) => {
    event.stopPropagation(); // Evitar que el evento se propague al elemento padre
    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error('Error al copiar:', error);
    }
  };

  return (
    <Tooltip title={copied ? 'Copiado!' : tooltip}>
      <IconButton
        size={size}
        onClick={handleCopy}
        className={`copy-button ${className}`}
        color={copied ? 'success' : 'default'}
      >
        {copied ? (
          <CheckIcon fontSize="small" />
        ) : (
          <ContentCopyIcon fontSize="small" />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default CopyButton;
